export default class RelatedEntity {
  public entityId: string = null;
  public entityType: string = null;
}
